import _, { cloneDeep } from 'lodash'
import { NlpModel } from '@feedyou-ai/feedbot-schema'

import { GenericFormData } from '../../types'
import { FeedbotThunk } from '../../../../store/types'
import { updateBotProperties } from '../../../../actions/bot'
import { featureValueSelector } from '../../../../store/features/selectors'
import { botFlowSelector } from '../../../../store/flow/selectors/botFlowSelector'
import { validateAndFixDuplicateIdsInNlpSettings } from '../../../../features/flowValidation'
import { adjustModelIdToNlpModelIdFormat } from '../../sharedSchemaFragments/nlpSettings/utils'

export const save =
  (params: { formData: GenericFormData; initialFormData: GenericFormData }): FeedbotThunk =>
  async (dispatch, getState) => {
    const state = getState()
    const flow = botFlowSelector(state)
    const isUniqueIdValidationEnabled = featureValueSelector('UNIQUE_BOT_ID_VALIDATION')(state)

    const model = params.initialFormData as NlpModel
    const updatedModel = params.formData as NlpModel

    const existingNlpModels = flow?.nlp?.models || []
    const otherModels = existingNlpModels.filter(({ id }) => id !== model.id)

    const modelId = adjustModelIdToNlpModelIdFormat(updatedModel?.id, otherModels)
    const settingsWithAdjustedIds = { models: [{ ...updatedModel, id: modelId }] }
    // Validation still required for nested objects - adjustModelIdsToNlpModelIdFormat
    // only regenerates ids od models themselves, but not on entities inside models (intents, entities, options)
    const duplicateIdsValidationResult = await validateAndFixDuplicateIdsInNlpSettings(
      settingsWithAdjustedIds,
      !isUniqueIdValidationEnabled
    )

    const { correctedEntity, didValidateSuccessfully } = duplicateIdsValidationResult
    if (didValidateSuccessfully) {
      const models = cloneDeep(existingNlpModels) as NlpModel[]
      const index = existingNlpModels.findIndex(({ id }) => id === model.id)

      models[index] = _.last(correctedEntity?.models) as NlpModel
      dispatch(updateBotProperties({ nlp: { ...flow?.nlp, models } }))
    }
  }
